import { z } from 'zod';
/**
 * VEVOSZOLGALATI BEALLITAS (docs/20-vevoszolgalat.html).
 *
 * Aki tavoli asztalon dolgozik, annak a bejovo hivas es a hivasfunkciok a tavoli
 * asztal FOLOTT, egy lebego panelben jelenjenek meg. A beallitas HARMAS szintu:
 *
 *   szuperadmin (globalis alapertek)  <  ceg (admin)  <  felhasznalo (sajat)
 *
 * Minden szint minden mezoje `null` lehet: ez azt jelenti, hogy "nem allitottam"
 * - a feljebbi szint ertekere esik vissza. A ceg es a globalis szint ezen felul
 * `locked` (kotelezo) lehet: ilyenkor azok az ertekek, amiket ez a szint megad,
 * lentebb nem irhatok felul.
 */
export const SERVICE_SETTINGS_KEY = 'service';
/** A ket beallitas. `null` = nincs megadva (oroklodik). */
export const serviceFieldsSchema = z.object({
    /** Bekapcsolt-e a vevoszolgalati mod (lebego panel, a hivas a fo ablakban). */
    enabled: z.boolean().nullable().default(null),
    /** Az elso kattintasra/billentyure automatikusan megnyiljon-e a lebego panel. */
    autoOpen: z.boolean().nullable().default(null),
});
/** A globalis es a ceg szint: a mezok + a kotelezo jelzes. */
export const serviceLevelSchema = serviceFieldsSchema.extend({
    locked: z.boolean().default(false),
});
export const EMPTY_SERVICE_FIELDS = { enabled: null, autoOpen: null };
export const EMPTY_SERVICE_LEVEL = { ...EMPTY_SERVICE_FIELDS, locked: false };
/**
 * Az alapertek, ha SEMMILYEN szint nem mond semmit: kikapcsolva (a funkcio opt-in),
 * de ha bekapcsoljak, az automatikus nyitas jar hozza - e nelkul a panel nem lenne
 * ott, amikor a hivas megerkezik.
 */
export const DEFAULT_SERVICE = { enabled: false, autoOpen: true };
export const SERVICE_FIELDS = ['enabled', 'autoOpen'];
/**
 * A kesz ertek: globalis < ceg < felhasznalo, a kotelezo szintek figyelembevetelevel.
 *
 * TISZTA fuggveny: a szerver ezt futtatja (es a jogosultsag-ellenorzes is ebbol tudja,
 * melyik mezo zart), a tesztek ezt vizsgaljak.
 */
export function resolveService(levels) {
    const effective = { ...DEFAULT_SERVICE };
    const lockedBy = { enabled: null, autoOpen: null };
    const steps = [
        { source: 'global', level: levels.global },
        { source: 'team', level: levels.team },
        { source: null, level: levels.user },
    ];
    for (const { source, level } of steps) {
        for (const field of SERVICE_FIELDS) {
            const value = level[field];
            // Amit egy feljebbi, KOTELEZO szint mar lezart, azt lentebb nem irjuk felul.
            if (value === null || lockedBy[field] !== null)
                continue;
            effective[field] = value;
            if (level.locked && source !== null)
                lockedBy[field] = source;
        }
    }
    return { effective, lockedBy };
}
/** A felhasznalo kepe a beallitasrol - ezt kapja a felulet. */
export const serviceStatusSchema = z.object({
    effective: z.object({ enabled: z.boolean(), autoOpen: z.boolean() }),
    /** A felhasznalo SAJAT (nyers) ertekei - ezeket szerkeszti. */
    own: serviceFieldsSchema,
    lockedBy: z.object({
        enabled: z.enum(['global', 'team']).nullable(),
        autoOpen: z.enum(['global', 'team']).nullable(),
    }),
    /** A ceg es a globalis szint - a felulet ebbol irja ki, honnan jon az ertek. */
    team: serviceLevelSchema,
    global: serviceLevelSchema,
});
/** Szerkesztes: csak az adott mezok; `null` = vissza az oroklesre. */
export const updateServiceFieldsInput = z.object({
    enabled: z.boolean().nullable().optional(),
    autoOpen: z.boolean().nullable().optional(),
});
export const updateServiceLevelInput = updateServiceFieldsInput.extend({
    locked: z.boolean().optional(),
});
/** Az admin attekintese: egy kolléga sora. */
export const adminServiceUserSchema = z.object({
    id: z.string(),
    displayName: z.string(),
    teamId: z.string(),
    own: serviceFieldsSchema,
    effective: z.object({ enabled: z.boolean(), autoOpen: z.boolean() }),
    /** Mely mezot tett kotelezove a ceg vagy a rendszer - ott a kolléga erteke nem szamit. */
    lockedBy: z.object({
        enabled: z.enum(['global', 'team']).nullable(),
        autoOpen: z.enum(['global', 'team']).nullable(),
    }),
});
export const adminServiceOverviewSchema = z.object({
    /** A globalis szintet csak a szuperadmin szerkesztheti; az admin csak latja. */
    global: serviceLevelSchema,
    teams: z.array(z.object({ id: z.string(), name: z.string(), level: serviceLevelSchema })),
    users: z.array(adminServiceUserSchema),
});
//# sourceMappingURL=service.js.map